import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import Header from '../../Header/Header';
import Table from './Table/Table';
import Footer from '../../Footer/Footer';
import ApexChartBar from '../ApexChartBar';
import LineChart from '../LineChart';
import CustomChart from '../CustomChart';
import Rightarrow from '../../images/right-arrow.png';
import Leftarrow from '../../images/left-arrow.png';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const getCurrentMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1; // getMonth() returns 0-based index
    month = month < 10 ? `0${month}` : `${month}`;
    return `${year}-${month}`;
  };

  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
  const [tableData, setTableData] = useState([]);
  const [totalcount, setTotalCount] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    fetchData(selectedMonth);
    Monthcount(selectedMonth);
  }, [selectedMonth]);
  const Monthcount = async (month) => {
    try {
      const url = `https://zingapi.beeinnovations.com/boxoffice_app/activeuserscount.php?month=${month}`;
      
      const response = await axios.post(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (response.data ) {
        setTotalCount(response.data.count);
      } else {
        console.warn('No data received or invalid data format');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
 

  const fetchData = async (month) => {
    try {
      const url = 'https://zingapi.beeinnovations.com/boxoffice_app/consumer_detailsbkplimit.php';
      const requestData = { month: month };
      const response = await axios.post(url, requestData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      setTableData(response.data.consumer_details || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDownload = (format) => {
    if (!tableData.length) {
      alert('No data available for download');
      return;
    }
    if (format === 'csv') {
      downloadCSV();
    } else if (format === 'excel') {
      downloadExcel();
    }
  };

  const downloadCSV = () => {
    const csvData = XLSX.utils.json_to_sheet(tableData);
    const csv = XLSX.utils.sheet_to_csv(csvData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, 'DashboardData.csv');
  };

  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const tableSheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.book_append_sheet(workbook, tableSheet, 'Table');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'DashboardData.xlsx');
  };

  const handleSaveChanges = () => {
    // Handle saving changes based on selectedMonth state
    fetchData(selectedMonth);
    Monthcount(selectedMonth);
  };

  const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <img src={Rightarrow} alt='' width='20px' />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <img src={Leftarrow} alt='' width='20px' />
      </div>
    );
  };

  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />
  };

  const getMonthOptions = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    const options = [];
    for (let year = currentYear; year >= 2024; year--) {
      const endMonth = year === currentYear ? currentMonth : 12;
      const startMonth = year === 2024 ? 4 : 1;

      for (let month = endMonth; month >= startMonth; month--) {
        const monthStr = month < 10 ? `0${month}` : `${month}`;
        const yearMonth = `${year}-${monthStr}`;
        options.push({
          value: yearMonth,
          label: `${getFormattedMonth(yearMonth)}`
        });
      }
    }
    return options;
  };

  const handleCsvDownload = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const getFormattedMonth = (month) => {
    const date = new Date(month + '-01');
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };
  const date1= new Date(selectedMonth + '-01');
  var formattedDate  = date1.toLocaleString('en-US', { month: 'short', year: '2-digit' });

  return (
    <div>
      <Header />
      <div className='container-fluid maincontent'>
        <div className='d-flex justify-content-between'>
          <h5 className='title_text mt-2'>Dashboard</h5>
          <span className='d-lg-none d-xl-none '  onClick={() => {
                  localStorage.clear(); // Clear localStorage on logout
                  navigate('/Login'); // Navigate to Login page after logout
                }}><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#000" style={{backgroundColor:"#c6a8ff !important"}} className="bi bi-power border rounded rounded-2 " viewBox="0 0 16 16">
  <path d="M7.5 1v7h1V1z"/>
  <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812"/>
</svg></span>
        </div>
        <div className='d-flex justify-content-center d-lg-none d-xl-none  mt-1'>
          <p style={{ color: '#0a58ca', fontSize: '14px' }}>
            {' '}
            Active Users {formattedDate} - {totalcount}
          </p>
        </div>
        <div className='row'>
          <div className='col-lg-2 sidebar_top'>
            <div className='sidebar'>
              <center className='pt-4 ' style={{ color: '#0a58ca', fontSize: '14px' }}>
                {' '}
                Active Users {formattedDate} - {totalcount}
              </center>
              <div className='selectbtn'>
                <button className='btn' data-toggle='modal' data-target='#selectPeriodModal'>
                  Select Month
                </button>
              </div>
              {selectedMonth && (
                <div className='selected-period'>
                  <center className='mt-2'>
                    <p>{getFormattedMonth(selectedMonth)}</p>
                  </center>
                </div>
              )}
              <div  className=' downloadbtn'  onClick={handleDropdownToggle}  >
                <button className="btn " >
        Download Reports
                </button>

                
                {showDropdown && (
                  <div className="dropdown-menu " style={{ display: 'block', position: 'absolute', top: '100%', left:'0%' ,width:'100%' }}>
                    
                    <span className="dropdown-item  m-1" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-07.zip')}>
                      July' 24 Reports 
                    </span>
                    <span className="dropdown-item  m-1 " onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-06.zip')}>
                      June' 24 Reports 
                    </span>
                    <span className="dropdown-item  m-1" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-05.zip')}>
                      May' 24 Reports
                    </span>
                    <span className="dropdown-item  m-1" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-04.zip')}>
                      April' 24 Reports
                    </span>
                   
                 
                  
                  </div>
                )}
              </div>
              
              <div className='logout_btn'>
                <button className='btn ' onClick={() => navigate('/Login')}>
                  Logout
                </button>
              </div>
            </div>
          </div>
          <div className='col-lg-10 col-md-12 col-sm-12 sai_content'>
          <Slider {...settings}>
              <div>
                <center>
                  <h4 className='sai_responsive_name'>STV-PV Vs ZING User Count Report {getFormattedMonth(selectedMonth)}</h4>
                </center>
                {/* <div className='row my-2'>
                  <div className='tabledesign_row'>
                    <div className='col-lg-6 col-md-6 col-sm-6'>
                      <button className='newonbtn' data-toggle='modal' data-target='#selectPeriodModal'>
                        Select Month
                      </button>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 d-flex justify-content-end'>
                      <button className='newonbtn' data-toggle='modal' data-target='#downloadModal'>
                        Download Reports
                      </button>
                    </div>
                  </div>
                </div> */}
                <ApexChartBar selectedMonth={selectedMonth} />
                <p className='chart_desc'>
                The report indicates the counts of successful delivery of the preactivated ZING service to the bundled STV-PV recharges. The summary report showcases the best performing STV-PV packs till date of the month.
                </p>
              </div>
              <div>
                <center>
                  <h4 className='sai_responsive_name'>Circles Vs ZING User Count {getFormattedMonth(selectedMonth)}</h4>
                </center>
                {/* <div className='row my-2'>
                  <div className='tabledesign_row'>
                    <div className='col-lg-6 col-md-6 col-sm-6'>
                      <button className='newonbtn' data-toggle='modal' data-target='#selectPeriodModal'>
                        Select Month
                      </button>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 d-flex justify-content-end'>
                      <button className='newonbtn' onClick={() => setShowDownloadOptions(!showDownloadOptions)}>
                        Download Reports
                      </button>
                      {showDownloadOptions && (
                        <div className='mt-2'>
                          <select className='form-control' onChange={(e) => handleCsvDownload(e.target.value)}>
                            <option value=''>Select a month</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_04_data.csv'>April</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_05_data.csv'>May</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_06_data.csv'>June</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_07_data.csv'>July</option>
                         
                          </select>
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}
                                <LineChart selectedMonth={selectedMonth} />

                <p className='chart_desc'>
                The circle wise performance report showcases the successful delivery of ZING preactivated service url in each of the BSNL circles.  The report gives insight into the best performing circles; the circles with most potential of market penetration and the circles that are consistent in their performance  </p>
              </div>
              <div>
                <center>
                  <h4 className='sai_responsive_name'>ZING Active Users - Datewise Performance Report {getFormattedMonth(selectedMonth)}</h4>
                </center>
                {/* <div className='row my-2'>
                  <div className='tabledesign_row'>
                    <div className='col-lg-6 col-md-6 col-sm-6'>
                      <button className='newonbtn' data-toggle='modal' data-target='#selectPeriodModal'>
                        Select Month
                      </button>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 d-flex justify-content-end'>
                      <button className='newonbtn' onClick={() => setShowDownloadOptions(!showDownloadOptions)}>
                        Download Reports
                      </button>
                      {showDownloadOptions && (
                        <div className='mt-3'>
                          <select className='form-control' onChange={(e) => handleCsvDownload(e.target.value)}>
                            <option value=''>Select a month</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_04_data.csv'>April</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_05_data.csv'>May</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_06_data.csv'>June</option>
                            <option value='https://cms2024.s3.ap-south-1.amazonaws.com/2024_07_data.csv'>July</option>
                          </select>
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}
                <CustomChart selectedMonth={selectedMonth} />

                <p className='chart_desc'>
                The report indicates the statistics of the active users, who have consumed atleast one chargeable service url in the current period.                </p>
              </div>
            </Slider>
            <Table tableData={tableData} selectedMonth={selectedMonth} />
            <Footer />
          </div>
        </div>
        <div className='modal' id='selectPeriodModal'>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h4 className='modal-title'>Select Month</h4>
                <button type='button' className='close' data-dismiss='modal'>
                  &times;
                </button>
              </div>
              <div className='modal-body'>
                <select
                  className='form-control'
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  {getMonthOptions().map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className='modal-footer'>
                <button type='button' className='btn btn-primary' onClick={handleSaveChanges}>
                  Save changes
                </button>
                <button type='button' className='btn btn-secondary' data-dismiss='modal'>
                  Close
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
